import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as Yup from 'yup';
import { Text } from '@yoweb/ui/components/typography';
import { Grid } from '@yoweb/ui/components/Grid';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import AddressFormElements from '@poplar/components/AddressFormElements';
import { validatePostalCode } from '@yoweb/utils/postalCode';
import { convertPostalAddressToUserAddress } from '@poplar/utils/user';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getAddressInitialValues = function getAddressInitialValues(addressAnswer, country) {
  return convertPostalAddressToUserAddress(addressAnswer === null || addressAnswer === void 0 ? void 0 : addressAnswer.answeredValue, country);
};
export var getAddressValidationSchema = function getAddressValidationSchema(isOptional, country, t) {
  var requiredMessage = t('validation.required');
  return Yup.object().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: Yup.object(),
    otherwise: isOptional ? Yup.object() : Yup.object({
      street1: Yup.string().trim().required(requiredMessage),
      street2: Yup.string().trim().ensure(),
      city: Yup.string().trim().required(requiredMessage),
      region: Yup.string().trim().required(requiredMessage),
      postalCode: Yup.string().trim().required(requiredMessage).test({
        message: t('validation.zip-code'),
        test: function test(value) {
          return value ? validatePostalCode(country, value) : false;
        }
      }),
      country: Yup.string().trim().required(requiredMessage)
    })
  });
};
export var AddressElement = function AddressElement(_ref) {
  var _values$questionId;

  var id = _ref.id,
      instructionHint = _ref.instructionHint,
      isDisabled = _ref.isDisabled,
      formikProps = _ref.formikProps;

  var _id$split = id.split('.'),
      _id$split2 = _slicedToArray(_id$split, 2),
      questionId = _id$split2[0],
      index = _id$split2[1];

  var values = formikProps.values,
      setFieldValue = formikProps.setFieldValue;

  var setNestedValues = function setNestedValues(nestedValues) {
    return setFieldValue(id, nestedValues);
  };

  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small2",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(AddressFormElements, {
      fieldNamePrefix: "".concat(id, "."),
      values: values === null || values === void 0 ? void 0 : (_values$questionId = values[questionId]) === null || _values$questionId === void 0 ? void 0 : _values$questionId[index],
      setValues: setNestedValues,
      isDisabled: isDisabled
    })]
  });
};